import React from 'react';
import { Button } from '../ui/button';
import { Navigation, ExternalLink } from 'lucide-react';

const GoogleMapsButton = ({ coordinates, title, className = "" }) => {
  if (!coordinates?.lat || !coordinates?.lng) {
    return null;
  }

  const handleOpenGoogleMaps = () => {
    const { lat, lng } = coordinates;
    const query = encodeURIComponent(title || 'Spot panoramique');
    const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&destination_place_id=${query}`;
    
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Button 
      onClick={handleOpenGoogleMaps}
      className={`bg-blue-600 hover:bg-blue-700 text-white ${className}`}
      size="lg"
    >
      <Navigation className="w-5 h-5 mr-2" />
      Ouvrir dans Google Maps
      <ExternalLink className="w-4 h-4 ml-2" />
    </Button>
  );
};

export default GoogleMapsButton;